import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import shouldReduceMotion from '../util/shouldReduceMotion';

const useRevealOnReady = (isReady, resetKey) => {
  const location = useLocation();
  const navigationKey = useMemo(() => {
    if (typeof resetKey !== 'undefined') {
      return resetKey;
    }

    return location.key || `${location.pathname}${location.search}${location.hash}`;
  }, [location.hash, location.key, location.pathname, location.search, resetKey]);

  const [hasRevealed, setHasRevealed] = useState(() => shouldReduceMotion());

  useEffect(() => {
    setHasRevealed(shouldReduceMotion());
  }, [navigationKey]);

  useEffect(() => {
    if (!isReady || hasRevealed) {
      return undefined;
    }

    if (shouldReduceMotion()) {
      setHasRevealed(true);
      return undefined;
    }

    const frameId = window.requestAnimationFrame(() => {
      setHasRevealed(true);
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, [hasRevealed, isReady, navigationKey]);

  return hasRevealed;
};

export default useRevealOnReady;
